import React, {useEffect, useRef} from "react"
import styled from "styled-components"
import { gsap, TweenLite, Power3 } from "gsap";
gsap.registerPlugin(TweenLite);

const HotspotButton = ({handleOpenModal, order, btnTop, btnLeft}) => {
    const Hotspot = styled.button`
    left: ${btnLeft};
    top: ${btnTop};
    `
    return (
        <div className="hotspot btn-container" data-id={order}>
            <Hotspot onClick={handleOpenModal}>
                <span>{order}</span>
            </Hotspot>      
        </div>
    )
}

export default HotspotButton;